function haversineDistance(lat1: number, lon1: number, lat2: number, lon2: number) {
    const R = 6371; // Radius of the Earth in kilometers
    const toRadians = (degrees: number) => (degrees * Math.PI) / 180;

    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);
    const lat1Rad = toRadians(lat1);
    const lat2Rad = toRadians(lat2);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
}

export function findNearestPoint(referencePoint: google.maps.LatLng, points: google.maps.Marker[]) {
    const [refLat, refLon] = [referencePoint.lat(), referencePoint.lng()];
    let nearestPoint = null;
    let minDistance = Infinity;

    points.forEach((point) => {
        const [lat, lon] = [point.getPosition().lat(), point.getPosition().lng()];
        const distance = haversineDistance(refLat, refLon, lat, lon);

        if (distance < minDistance) {
            minDistance = distance;
            nearestPoint = [lat, lon];
        }
    });

    return { nearestPoint, distance: minDistance };
}
